import { useTranslate } from 'core/hooks/useTranslate';
import { AssetImage, Dialog, TextHtml } from 'ui';
import React, { useState } from 'react';

const LandingEdelvivesPlus = () => {
  const { t } = useTranslate();

  const [showKnowMore, setShowKnowMore] = useState(false);

  function onOpenKnowMore() {
    setShowKnowMore(true);
  }

  function onCloseKnowMore() {
    setShowKnowMore(false);
  }

  return (
    <div className="landing-edelvives-plus">
      <div className="landing-edelvives__wrapper">
        <div className="landing-edelvives-plus__logo">
          <AssetImage id="logoWhite" alt={t('alt:Edelvives logo')} />
        </div>
        <div className="landing-edelvives-plus__text">{t('auth:Edelvives virtual learning environment')}</div>
        <button aria-haspopup="dialog" className="button-accessibility-only landing-edelvives__know-more" onClick={onOpenKnowMore} type="button">
          <span>{t('auth:Know more')}</span>
        </button>
      </div>
      <Dialog isOpen={showKnowMore} size="l" className={'dialog-show-know-more'} title={t('auth:Know more')} onClose={onCloseKnowMore}>
        <div className="dialog-show-know-more__container">
          <TextHtml text={t('auth:Know more text')} />
        </div>
      </Dialog>
    </div>
  );
};

export default LandingEdelvivesPlus;
